import styled from 'styled-components';
import { hexToRGB, typography } from '@/styles/helpers';

export const ScVipTransferGuestCard = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  & .content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
    & .title {
      text-transform: uppercase;
      ${typography.headline3mobile};
    }
    & .description {
      ${typography.body1bold};
      color: ${({ theme }) => hexToRGB(theme.whiteColor, 0.6)};
      letter-spacing: 0;
      font-weight: 400;
    }
  }
`;
